var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:[{ 'not-active': !_vm.buttonCanBeClicked }, _vm.variant],attrs:{"type":"button"},on:{"click":_vm.clickedButton}},[_c('div',{class:{ 'not-visible': !_vm.buttonCanBeClicked }},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }